import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dValidation$dSemigroup from "../Data.Validation.Semigroup/index.js";
import * as Data$dVault from "../Data.Vault/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Record$dBuilder from "../Record.Builder/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Restaumatic$dCommon$dTranslations$dKeys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dFormField from "../Specular.FormField/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dProfiling from "../Specular.Profiling/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Specular$dSelect from "../Specular.Select/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $ContextInitializer = (_1, _2) => ({tag: "ContextInitializer", _1, _2});
const $InitialValueInitializer = (_1, _2) => ({tag: "InitialValueInitializer", _1, _2});
const $NoInitialValue = () => ({tag: "NoInitialValue"});
const $NoInitializer = () => ({tag: "NoInitializer"});
const $SomeInitialValue = _1 => ({tag: "SomeInitialValue", _1});
const $Strictness = tag => ({tag});
const $TypedValue = (tag, _1) => ({tag, _1});
const $WithId = _1 => ({tag: "WithId", _1});
const WithOptions = x => x;
const WithId = value0 => $WithId(value0);
const Undefined = value0 => $TypedValue("Undefined", value0);
const Invalid = value0 => $TypedValue("Invalid", value0);
const Valid = value0 => $TypedValue("Valid", value0);
const Strict = /* #__PURE__ */ $Strictness("Strict");
const Lax = /* #__PURE__ */ $Strictness("Lax");
const SomeInitialValue = value0 => $SomeInitialValue(value0);
const RefWithOptions = x => x;
const NoInitializer = /* #__PURE__ */ $NoInitializer();
const NoInitialValue = /* #__PURE__ */ $NoInitialValue();
const MappedField = x => x;
const InitialValueInitializer = value0 => value1 => $InitialValueInitializer(value0, value1);
const FormDefM = x => x;
const EffectInitializer = x => x;
const ContextInitializer = value0 => value1 => $ContextInitializer(value0, value1);
const Attribute = x => x;
const queryFormField = dictTypeEquals => (
  {
    queryWith: v => {
      const $0 = Restaumatic$dForm$dFinal.functorFinal.map(dictTypeEquals.proof(a => a));
      return x => $0(Specular$dFormField.finalValueNoErr(x));
    }
  }
);
const mergeRef = dictTypeEquals => (
  {
    merge: x => ref => {
      const $0 = dictTypeEquals.proof(a => a)(x);
      return ref._2(_old => $0);
    }
  }
);
const maybeGetInitializer$pTrue = dictIsSymbol => () => ({"maybeGetInitializer'": v => label => Record.get(dictIsSymbol)()(label)});
const maybeGetInitializer$pFalse = {"maybeGetInitializer'": v => v1 => v2 => NoInitializer};
const maybeGetInitialValue$pTrue = dictIsSymbol => () => (
  {"maybeGetInitialValue'": v => label => x => $SomeInitialValue(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(label))(x))}
);
const maybeGetInitialValue$pFals = {"maybeGetInitialValue'": v => v1 => v2 => NoInitialValue};
const isRefLikeRef = {
  readRefLike: x => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(x._1),
  writeRefLike: ref => v => {
    if (v.tag === "Valid") {
      const $0 = v._1.value;
      return ref._2(_old => $0);
    }
    return () => {};
  },
  touchRefLike: v => () => {}
};
const isCheckboxFieldRefBoolean = {checkboxInput: f => Specular$dInternal$dRIO.pureImpl({onChange: value => f._2(_old => value), displayedValue: f._1})};
const isCheckboxFieldFormFieldB = {checkboxInput: field => Specular$dInternal$dRIO.pureImpl({onChange: value => field.editRef._2(_old => value), displayedValue: field.editRef._1})};
const hasFieldIdWithId = {getFieldId: v => v._1.id};
const hasFieldIdString = {getFieldId: x => x};
const hasFieldIdRef = () => ({getFieldId: v => ""});
const hasFieldIdFormField = () => ({getFieldId: v => ""});
const hasFieldIdChoiceRef = () => ({getFieldId: v => ""});
const hasErrorsRef = {
  displayedErrors: v => {
    const n = Specular$dInternal$dIncremental.constant([]);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const hasErrorsChoiceRef = {
  displayedErrors: v => {
    const n = Specular$dInternal$dIncremental.constant([]);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const hasContextRefContext = {getContext: Specular$dRef.value};
const hasContextContext = /* #__PURE__ */ (() => ({getContext: Specular$dFRP$dBase.applicativeDynamic.pure}))();
const addContextRef = {addContext: v => v1 => () => {}};
const addContextFormField = {addContext: v => v1 => () => {}};
const addContextEffect = {addContext: v => v1 => () => {}};
const addContextDynamic = {addContext: v => v1 => () => {}};
const writeRefLike = dict => dict.writeRefLike;
const writeRef = ref => value => ref._2(_old => value);
const isTextFieldFormFieldStrin = {
  textInput: f => (
    {
      onChange: value => f.editRef._2(_old => value),
      onTouch: f.focusOutCallback(),
      displayedValue: f.editRef._1,
      placeholder: (() => {
        const n = Specular$dInternal$dIncremental.constant("");
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })()
    }
  )
};
const isTextFieldRefString = {
  textInput: f => (
    {
      onChange: value => f._2(_old => value),
      onTouch: () => {},
      displayedValue: f._1,
      placeholder: (() => {
        const n = Specular$dInternal$dIncremental.constant("");
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })()
    }
  )
};
const withInitialValue = InitialValueInitializer;
const withId = id => field => $WithId({id, field});
const withFinal_ = dictMonadReplace => dictMonadFRP => f => block => Specular$dFRP$dReplaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(f))((() => {
  const $0 = dictMonadFRP.MonadCleanup1().Monad0().Applicative0();
  const $1 = $0.Apply0();
  const $2 = $0.pure();
  return v1 => {
    if (v1.tag === "Nothing") { return $2; }
    if (v1.tag === "Just") { return $1.apply($1.Functor0().map(v => x => x)(block(v1._1)))($2); }
    $runtime.fail();
  };
})());
const withEffect = EffectInitializer;
const withContext = ContextInitializer;
const validateWhenJust = validation => paramF => value => Restaumatic$dForm$dFinal.bindFinal(paramF)(v => {
  if (v.tag === "Nothing") { return Restaumatic$dForm$dFinal.applicativeFinal.pure([]); }
  if (v.tag === "Just") { return validation(Restaumatic$dForm$dFinal.applicativeFinal.pure(v._1))(value); }
  $runtime.fail();
});
const validateTrue = /* #__PURE__ */ (() => Restaumatic$dForm$dFinal.functorFinal.map(v => {
  const $0 = !v;
  const $1 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})];
  if (!$0) { return []; }
  if ($0) { return $1; }
  $runtime.fail();
}))();
const validateJust = validation => value => Restaumatic$dForm$dFinal.bindFinal(value)(v => {
  if (v.tag === "Just") { return validation(Restaumatic$dForm$dFinal.applicativeFinal.pure(v._1)); }
  if (v.tag === "Nothing") { return Restaumatic$dForm$dFinal.applicativeFinal.pure([]); }
  $runtime.fail();
});
const unFinalWithDefault = def => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Nothing") { return def; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  });
  return x => $0(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(x));
};
const unFinalFromContextDef = d => key => ctxRef => Specular$dFRP$dBase.bindDynamic.bind(ctxRef._1)(context1 => {
  const $0 = (() => {
    const n = Specular$dInternal$dIncremental.constant(d);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })();
  const $1 = unFinalWithDefault(d);
  const $2 = Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(key)(context1);
  if ($2.tag === "Just") { return $1($2._1); }
  return $0;
});
const touchRefLike = dict => dict.touchRefLike;
const toRecord = dict => dict.toRecord;
const textInput = dict => dict.textInput;
const isTextFieldWithId = dictIsTextField => ({textInput: v => dictIsTextField.textInput(v._1.field)});
const tagErrors = fieldName => errors => {
  const v = Data$dMap$dInternal.lookup(Data$dMaybe.ordMaybe(Data$dOrd.ordArray(Data$dOrd.ordString)))(Data$dMaybe.Nothing)(errors);
  return (() => {
    if (v.tag === "Just") {
      return Data$dMap$dInternal.insertWith(Data$dMaybe.ordMaybe(Data$dOrd.ordArray(Data$dOrd.ordString)))(Data$dSemigroup.concatArray)(Data$dMaybe.$Maybe("Just", fieldName))(Data$dFunctor.arrayMap(error => (
        {...error, fieldName: Data$dMaybe.$Maybe("Just", fieldName)}
      ))(v._1));
    }
    if (v.tag === "Nothing") { return x => x; }
    $runtime.fail();
  })()(Data$dMap$dInternal.delete(Data$dMaybe.ordMaybe(Data$dOrd.ordArray(Data$dOrd.ordString)))(Data$dMaybe.Nothing)(errors));
};
const singleOption = label => key => Specular$dSelect.$Option("SingleOption", {label, key, disabled: false});
const withOptions = field => label => ({field, toOption: a => Specular$dSelect.$Option("SingleOption", {label: label(a), key: a, disabled: false})});
const selectWriteValue = dict => dict.selectWriteValue;
const selectTouch = dict => dict.selectTouch;
const selectReadValue = dict => dict.selectReadValue;
const selectGetOptions = dict => dict.selectGetOptions;
const selectInput = dictShow => dictEq => dictIsSelectField => ff => Specular$dInternal$dRIO.pureImpl({
  onChange: v => {
    if (v.tag === "Just") { return dictIsSelectField.selectWriteValue(ff)(v._1); }
    if (v.tag === "Nothing") { return () => {}; }
    $runtime.fail();
  },
  displayedValue: Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(dictIsSelectField.selectReadValue(ff)),
  displayedOptions: Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v => v1 => Data$dSemigroup.concatArray((() => {
    if (v1.tag === "Just") {
      if (
        Data$dArray.any((() => {
          const $0 = v1._1;
          return v1$1 => {
            if (v1$1.tag === "SingleOption") { return dictEq.eq(v1$1._1.key)($0); }
            if (v1$1.tag === "OptGroup") { return Data$dArray.any(o => dictEq.eq(o.key)($0))(v1$1._1.options); }
            $runtime.fail();
          };
        })())(v)
      ) {
        return [];
      }
      return [Specular$dSelect.$Option("SingleOption", {key: Data$dMaybe.$Maybe("Just", v1._1), label: dictShow.show(v1._1), disabled: false})];
    }
    if (v1.tag === "Nothing") { return [Specular$dSelect.$Option("SingleOption", {key: Data$dMaybe.Nothing, label: "", disabled: false})]; }
    $runtime.fail();
  })())(Data$dFunctor.arrayMap(Specular$dSelect.functorOption.map(Data$dMaybe.Just))(v)))(dictIsSelectField.selectGetOptions(ff)))(dictIsSelectField.selectReadValue(ff)),
  onTouch: dictIsSelectField.selectTouch(ff)
});
const isSelectFieldWithId = dictIsSelectField => (
  {
    selectWriteValue: v => dictIsSelectField.selectWriteValue(v._1.field),
    selectReadValue: v => dictIsSelectField.selectReadValue(v._1.field),
    selectGetOptions: v => dictIsSelectField.selectGetOptions(v._1.field),
    selectTouch: v => dictIsSelectField.selectTouch(v._1.field)
  }
);
const requiredError = v => Restaumatic$dForm$dFinal.userVisibleError(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required),
  {}
));
const readRefLike = dict => dict.readRefLike;
const isRefLikeFormField = {
  readRefLike: x => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(x.editRef._1),
  writeRefLike: x => {
    const $0 = x.editRef;
    return v => {
      if (v.tag === "Valid") {
        const $1 = v._1.value;
        return $0._2(_old => $1);
      }
      return () => {};
    };
  },
  touchRefLike: field => field.focusOutCallback()
};
const isRefLikeWithId = dictIsRefLike => (
  {writeRefLike: v => dictIsRefLike.writeRefLike(v._1.field), readRefLike: v => dictIsRefLike.readRefLike(v._1.field), touchRefLike: v => dictIsRefLike.touchRefLike(v._1.field)}
);
const queryWith = dict => dict.queryWith;
const queryT2T2 = dictQuery => dictQuery1 => (
  {
    queryWith: strictness => v => Restaumatic$dForm$dFinal.applyFinal.apply(Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dTuple$dT2.T2))(dictQuery.queryWith(strictness)(v._1)))(dictQuery1.queryWith(strictness)(v._2))
  }
);
const queryUnit = dictTypeEquals => ({queryWith: v => v1 => Restaumatic$dForm$dFinal.applicativeFinal.pure()});
const queryRef = dictTypeEquals => (
  {
    queryWith: v => {
      const $0 = Restaumatic$dForm$dFinal.functorFinal.map(dictTypeEquals.proof(a => a));
      return x => $0(Restaumatic$dForm$dFinal.liftDynamic(x._1));
    }
  }
);
const queryRecordNil = {queryRecord: v => v1 => v2 => Restaumatic$dForm$dFinal.applicativeFinal.pure(x => x)};
const queryRecord = dict => dict.queryRecord;
const queryRecordCons = dictIsSymbol => dictQueryRecord => dictQuery => () => () => () => () => (
  {
    queryRecord: strictness => v => f => Restaumatic$dForm$dFinal.applyFinal.apply(Specular$dFRP$dBase.functorDynamic.map(m => {
      if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
      if (m.tag === "Right") {
        return Data$dEither.$Either(
          "Right",
          (() => {
            const $0 = m._1;
            return v2 => x => Record$dBuilder.unsafeInsert(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))($0)(v2(x));
          })()
        );
      }
      $runtime.fail();
    })(dictQuery.queryWith(strictness)(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f))))(dictQueryRecord.queryRecord(strictness)(Type$dProxy.Proxy)(f))
  }
);
const queryLaxWithDefault = dictQuery => def => {
  const $0 = unFinalWithDefault(def);
  const $1 = dictQuery.queryWith(Lax);
  return x => $0($1(x));
};
const queryLax = dictQuery => dictQuery.queryWith(Lax);
const queryFinal = dictTypeEquals => ({queryWith: v => Restaumatic$dForm$dFinal.functorFinal.map(dictTypeEquals.proof(a => a))});
const queryDynamic = dictTypeEquals => (
  {
    queryWith: v => {
      const $0 = Restaumatic$dForm$dFinal.functorFinal.map(dictTypeEquals.proof(a => a));
      return x => $0(Restaumatic$dForm$dFinal.liftDynamic(x));
    }
  }
);
const query = dictQuery => dictQuery.queryWith(Strict);
const optionForEq = () => Unsafe$dCoerce.unsafeCoerce;
const nonEmpty = /* #__PURE__ */ (() => Restaumatic$dForm$dFinal.functorFinal.map(s => {
  const $0 = s === "";
  const $1 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})];
  if (!$0) { return []; }
  if ($0) { return $1; }
  $runtime.fail();
}))();
const monadFormDefM = Specular$dInternal$dRIO.monadRIO;
const monadEffectFormDefM = Specular$dInternal$dRIO.monadEffectRIO;
const monadCleanupFormDefM = Specular$dFRP$dHost.monadCleanupHost;
const mergeUnit = dictTypeEquals => ({merge: v => v1 => () => {}});
const mergeRecordNil = {mergeRecord: v => v1 => v2 => () => {}};
const mergeRecord = dict => dict.mergeRecord;
const merge_Record = dictAsRecord => () => dictMergeRecord => ({merge: d => f => dictMergeRecord.mergeRecord(Type$dProxy.Proxy)(dictAsRecord.toRecord(d))(f)});
const mergeInputRequired = dict => dict.mergeInputRequired;
const merge = dict => dict.merge;
const mergeRecordCons = dictIsSymbol => dictMergeRecord => dictMerge => () => () => () => () => (
  {
    mergeRecord: v => r => f => {
      const $0 = Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("merge " + dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(dictMerge.merge(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(r))(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f)));
      return () => {
        $0();
        return dictMergeRecord.mergeRecord(Type$dProxy.Proxy)(r)(f)();
      };
    }
  }
);
const mergeT2T2 = dictMerge => dictMerge1 => (
  {
    merge: v => v1 => {
      const $0 = v._2;
      const $1 = v1._2;
      const $2 = dictMerge.merge(v._1)(v1._1);
      return () => {
        $2();
        return dictMerge1.merge($0)($1)();
      };
    }
  }
);
const maybeGetInitializer$p = dict => dict["maybeGetInitializer'"];
const maybeGetInitializer1 = () => dictMaybeGetInitializer$p => ({maybeGetInitializer: dictMaybeGetInitializer$p["maybeGetInitializer'"](Type$dProxy.Proxy)});
const maybeGetInitializer = dict => dict.maybeGetInitializer;
const maybeGetInitialValue$p = dict => dict["maybeGetInitialValue'"];
const maybeGetInitialValue1 = () => dictMaybeGetInitialValue$p => ({maybeGetInitialValue: dictMaybeGetInitialValue$p["maybeGetInitialValue'"](Type$dProxy.Proxy)});
const maybeGetInitialValue = dict => dict.maybeGetInitialValue;
const mapVFinal = f => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Left") { return Data$dEither.$Either("Left", v2._1); }
  if (v2.tag === "Right") { return f(v2._1); }
  $runtime.fail();
});
const mapMaybeFinalUserVisible = errorMessage => f => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Left") { return Data$dEither.$Either("Left", v2._1); }
  if (v2.tag === "Right") {
    const v = f(v2._1);
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", Restaumatic$dForm$dFinal.userVisibleError(errorMessage)); }
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    $runtime.fail();
  }
  $runtime.fail();
});
const mapMaybeFinalInternal = errorMessage => f => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Left") { return Data$dEither.$Either("Left", v2._1); }
  if (v2.tag === "Right") {
    const v = f(v2._1);
    if (v.tag === "Nothing") {
      return Data$dEither.$Either(
        "Left",
        Data$dMap$dInternal.$$$Map(
          "Two",
          Data$dMap$dInternal.Leaf,
          Data$dMaybe.Nothing,
          [{fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message: errorMessage, internal: true}],
          Data$dMap$dInternal.Leaf
        )
      );
    }
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    $runtime.fail();
  }
  $runtime.fail();
});
const mapMaybeFinal = /* #__PURE__ */ mapMaybeFinalInternal("Unknown error (mapMaybeFinal)");
const mapDynamicFinal = f => x => Specular$dFRP$dBase.bindDynamic.bind(x)(Data$dValidation$dSemigroup.traversableV.traverse(Specular$dFRP$dBase.applicativeDynamic)(f));
const makeWithInitialValueInitializer = dict => dict.makeWithInitialValueInitializer;
const initializeInitialValueIni = dictMakeWithInitialValueInitializer => ({makeImpl: dictMakeWithInitialValueInitializer.makeWithInitialValueInitializer});
const makeRecordImpl = dict => dict.makeRecordImpl;
const initializeSomeInitialValu = dictAsRecord => () => dictInitializeRecord => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitializeRecord.makeRecordImpl(p)(Type$dProxy.Proxy)(opts))(v => Specular$dInternal$dRIO.pureImpl({
      field: v.field({}),
      init: v1 => v.init(dictAsRecord.toRecord(v1._1))
    }))
  }
);
const makeImpl = dict => dict.makeImpl;
const makeWithDefaultInitializer = dictInitialize => defaultInitializer => p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
  field: v.field,
  init: iv => v1 => v.init(iv)(defaultInitializer)
}));
const initializeNoInitializerRe = dictInitialize => ({makeImpl: makeWithDefaultInitializer(dictInitialize)({})});
const initializeNoInitialValueR = dictInitialize => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
      field: v.field,
      init: v1 => v.init($SomeInitialValue({}))
    }))
  }
);
const makeWithInitialValueIniti = dictInitialize => (
  {
    makeWithInitialValueInitializer: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
      field: v.field,
      init: v1 => v2 => v.init($SomeInitialValue(v2._1))(v2._2)
    }))
  }
);
const makeWithInitialValueIniti1 = dictInitialize => (
  {
    makeWithInitialValueInitializer: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
      field: v.field,
      init: given_iv => v1 => v.init(given_iv)(v1._2)
    }))
  }
);
const makeEmptyRecordNil = {makeEmptyRecord: v => v1 => () => x => x};
const makeEmptyRecord = dict => dict.makeEmptyRecord;
const makeEmpty_Record = () => dictMakeEmptyRecord => (
  {
    makeEmptyImpl: opts => {
      const $0 = dictMakeEmptyRecord.makeEmptyRecord(Type$dProxy.Proxy)(opts);
      return () => {
        const b = $0();
        return b({});
      };
    }
  }
);
const makeEmptyMaybe = {makeEmptyImpl: v => () => Data$dMaybe.Nothing};
const makeEmptyImpl = dict => dict.makeEmptyImpl;
const makeEmptyRecordCons = dictIsSymbol => dictMakeEmptyRecord => dictMakeEmpty => () => () => (
  {
    makeEmptyRecord: v => opts => {
      const $0 = dictMakeEmpty.makeEmptyImpl({name: Data$dSemigroup.concatArray(opts.name)([dictIsSymbol.reflectSymbol(Type$dProxy.Proxy)])});
      return () => {
        const x = $0();
        const xs = dictMakeEmptyRecord.makeEmptyRecord(Type$dProxy.Proxy)(opts)();
        return x$1 => Record$dBuilder.unsafeInsert(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(x)(xs(x$1));
      };
    }
  }
);
const makeEmptyT2 = dictMakeEmpty => dictMakeEmpty1 => (
  {
    makeEmptyImpl: opts => {
      const $0 = dictMakeEmpty.makeEmptyImpl({name: Data$dSemigroup.concatArray(opts.name)(["0"])});
      const $1 = dictMakeEmpty1.makeEmptyImpl({name: Data$dSemigroup.concatArray(opts.name)(["1"])});
      return () => {
        const a$p = $0();
        const a$p$1 = $1();
        return Data$dTuple$dT2.$T2(a$p, a$p$1);
      };
    }
  }
);
const makeEmpty = dictMonadEffect => dictMakeEmpty => dictMonadEffect.liftEffect(dictMakeEmpty.makeEmptyImpl({name: []}));
const mSelectWriteValue = dict => dict.mSelectWriteValue;
const mSelectTouch = dict => dict.mSelectTouch;
const mSelectReadValue = dict => dict.mSelectReadValue;
const mSelectGetOptions = dict => dict.mSelectGetOptions;
const liftMaybe = x => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Nothing") { return Data$dEither.$Either("Left", Restaumatic$dForm$dFinal.unknownError); }
  if (v2.tag === "Just") { return Data$dEither.$Either("Right", v2._1); }
  $runtime.fail();
})((() => {
  const n = Specular$dInternal$dIncremental.constant(x);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})());
const lessThanOrEqual = dictOrd => dictShow => a => b => Restaumatic$dForm$dFinal.applyFinal.apply(Restaumatic$dForm$dFinal.applyFinal.Functor0().map(threshold => value => {
  const $0 = [
    Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.lessThanOrEqual),
      {threshold: dictShow.show(threshold)}
    )
  ];
  if (!(dictOrd.compare(value)(threshold).tag === "GT")) { return []; }
  return $0;
})(a))(b);
const lessThan = dictOrd => dictShow => a => b => Restaumatic$dForm$dFinal.applyFinal.apply(Restaumatic$dForm$dFinal.applyFinal.Functor0().map(threshold => value => {
  const $0 = [
    Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.lessThan),
      {threshold: dictShow.show(threshold)}
    )
  ];
  if (dictOrd.compare(value)(threshold).tag === "LT") { return []; }
  return $0;
})(a))(b);
const isSelectFieldRefWithOptions = dictIsRefLike => (
  {
    selectWriteValue: v => value => dictIsRefLike.writeRefLike(v.field)($TypedValue("Valid", {value, editValue: Data$dMaybe.Nothing})),
    selectReadValue: v => dictIsRefLike.readRefLike(v.field),
    selectGetOptions: v => v.choices,
    selectTouch: v => dictIsRefLike.touchRefLike(v.field)
  }
);
const isSelectFieldChoiceRef = {
  selectWriteValue: v => a => v.field.currentChoice._2(_old => a),
  selectReadValue: v => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(v.field.currentChoice._1),
  selectGetOptions: v => Specular$dFRP$dBase.functorDynamic.map(Data$dFunctor.arrayMap(v.toOption))(v.field.choices),
  selectTouch: v => () => {}
};
const isMultiSelectFieldMultiChoiceRef = {
  mSelectWriteValue: v => a => v.field.currentChoices._2(_old => a),
  mSelectReadValue: v => v.field.currentChoices._1,
  mSelectGetOptions: v => Specular$dFRP$dBase.functorDynamic.map(Data$dFunctor.arrayMap(v.toOption))(v.field.choices),
  mSelectTouch: v => () => {}
};
const hasOptionsSingle = {};
const hasOptionsSet = {};
const hasOptionsSMultiSet = {};
const hasOptionsArray = {};
const hasErrorsOldFormField = {displayedErrors: Specular$dFormField.displayedErrors};
const hasErrorsErrorArray = {displayedErrors: /* #__PURE__ */ unFinalWithDefault([])};
const greaterThanOrEqual = dictOrd => dictShow => a => b => Restaumatic$dForm$dFinal.applyFinal.apply(Restaumatic$dForm$dFinal.applyFinal.Functor0().map(threshold => value => {
  const $0 = [
    Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.greaterThanOrEqual),
      {threshold: dictShow.show(threshold)}
    )
  ];
  if (!(dictOrd.compare(value)(threshold).tag === "LT")) { return []; }
  return $0;
})(a))(b);
const greaterThan = dictOrd => dictShow => a => b => Restaumatic$dForm$dFinal.applyFinal.apply(Restaumatic$dForm$dFinal.applyFinal.Functor0().map(threshold => value => {
  const $0 = [
    Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.greaterThan),
      {threshold: dictShow.show(threshold)}
    )
  ];
  if (dictOrd.compare(value)(threshold).tag === "GT") { return []; }
  return $0;
})(a))(b);
const getFieldId = dict => dict.getFieldId;
const hasFieldIdRefWithOptions = dictHasFieldId => ({getFieldId: v => dictHasFieldId.getFieldId(v.field)});
const hasFieldIdWithOptions = dictHasFieldId => ({getFieldId: v => dictHasFieldId.getFieldId(v.field)});
const getContext = dict => dict.getContext;
const unFinalFromContext = dictHasContext => key => field => Specular$dFRP$dBase.bindDynamic.bind(dictHasContext.getContext(field))(ctx => {
  const $0 = (() => {
    const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })();
  const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(key)(ctx);
  if ($1.tag === "Just") { return Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)($1._1); }
  return $0;
});
const genericTypedValue = {
  to: x => {
    if (x.tag === "Inl") { return $TypedValue("Undefined", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $TypedValue("Invalid", x._1._1); }
      if (x._1.tag === "Inr") { return $TypedValue("Valid", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Undefined") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "Invalid") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "Valid") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const showTypedValue = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor({
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
              "lastValid",
              (() => {
                if (v.lastValid.tag === "NoValue") { return "noValue"; }
                if (v.lastValid.tag === "SomeValue") { return "(SomeValue " + dictShow.show(v.lastValid._1) + ")"; }
                $runtime.fail();
              })()
            ]))([]);
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      })({reflectSymbol: () => "Undefined"});
      const $1 = Data$dShow$dGeneric.genericShowConstructor({
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
              "editValue",
              (() => {
                if (v.editValue.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.editValue._1) + ")"; }
                if (v.editValue.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["error", Restaumatic$dForm$dFinal.showFormErrors.show(v.error)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "lastValid",
              (() => {
                if (v.lastValid.tag === "NoValue") { return "noValue"; }
                if (v.lastValid.tag === "SomeValue") { return "(SomeValue " + dictShow.show(v.lastValid._1) + ")"; }
                $runtime.fail();
              })()
            ]))([])));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      })({reflectSymbol: () => "Invalid"});
      const $2 = Data$dShow$dGeneric.genericShowConstructor({
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
              "editValue",
              (() => {
                if (v.editValue.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.editValue._1) + ")"; }
                if (v.editValue.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["value", dictShow.show(v.value)]))([]));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      })({reflectSymbol: () => "Valid"});
      return x => {
        const $3 = genericTypedValue.from(x);
        if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
        if ($3.tag === "Inr") {
          if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
          if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      };
    })()
  }
);
const functorFormDefM = Specular$dInternal$dRIO.functorRIO;
const fromRecord = dict => dict.fromRecord;
const query_Record = dictAsRecord => () => dictQueryRecord => (
  {
    queryWith: strictness => f => Specular$dFRP$dBase.functorDynamic.map(m => {
      if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
      if (m.tag === "Right") { return Data$dEither.$Either("Right", dictAsRecord.fromRecord(m._1({}))); }
      $runtime.fail();
    })(dictQueryRecord.queryRecord(strictness)(Type$dProxy.Proxy)(f))
  }
);
const fromChoices = dictFoldable => dictIsRefLike => field => cs => (
  {
    field,
    choices: Specular$dFRP$dBase.functorDynamic.map(Data$dFunctor.arrayMap(r => Specular$dSelect.$Option("SingleOption", {label: r.name, key: r.id, disabled: false})))(Specular$dFRP$dBase.functorDynamic.map(Data$dArray.fromFoldableImpl(dictFoldable.foldr))(cs))
  }
);
const forceDisplayErrorsKey = /* #__PURE__ */ Data$dVault.newKey();
const forceDisplayErrors = /* #__PURE__ */ Data$dVault.singleton(forceDisplayErrorsKey);
const fieldPathToString = /* #__PURE__ */ Data$dString$dCommon.joinWith(".");
const failFirst = validations_ => value => Restaumatic$dForm$dFinal.bindFinal(value)(value_ => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Nothing") { return Data$dEither.$Either("Left", Restaumatic$dForm$dFinal.unknownError); }
  if (v2.tag === "Just") { return Data$dEither.$Either("Right", v2._1); }
  $runtime.fail();
})(Specular$dFRP$dBase.functorDynamic.map((() => {
  const $0 = Data$dFoldable.find(Data$dFoldable.foldableArray)(e => Data$dFoldable.foldlArray(c => v => 1 + c | 0)(0)(e) > 0);
  return x => Data$dMaybe.$Maybe(
    "Just",
    (() => {
      const $1 = $0(x);
      if ($1.tag === "Nothing") { return []; }
      if ($1.tag === "Just") { return $1._1; }
      $runtime.fail();
    })()
  );
})())(Data$dTraversable.traversableArray.traverse(Specular$dFRP$dBase.applicativeDynamic)(x => x)(Data$dFunctor.arrayMap((() => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Nothing") { return []; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  });
  return x => $0(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(x(Restaumatic$dForm$dFinal.applicativeFinal.pure(value_))));
})())(validations_)))));
const eqStrictness = {
  eq: x => y => {
    if (x.tag === "Strict") { return y.tag === "Strict"; }
    if (x.tag === "Lax") { return y.tag === "Lax"; }
    return false;
  }
};
const encodeTypedValue = dictEncode => dictEncodeWithOptions => (
  {
    encode: Foreign$dEncoding.defaultEncode(genericTypedValue)((() => {
      const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Undefined"})((() => {
        const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "lastValid"})({
          encodeWithOptions: v => x => {
            if (x.tag === "NoValue") { return Foreign$dNullOrUndefined.nullImpl; }
            if (x.tag === "SomeValue") { return dictEncode.encode(x._1); }
            $runtime.fail();
          }
        });
        return {
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
            Data$dList$dTypes.Nil
          )
        };
      })());
      const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Invalid"})((() => {
        const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "lastValid"
        })({
          encodeWithOptions: v => x => {
            if (x.tag === "NoValue") { return Foreign$dNullOrUndefined.nullImpl; }
            if (x.tag === "SomeValue") { return dictEncode.encode(x._1); }
            $runtime.fail();
          }
        }))({reflectSymbol: () => "error"})({encodeWithOptions: v => Restaumatic$dForm$dFinal.encodeFormErrors.encode}))({reflectSymbol: () => "editValue"})({
          encodeWithOptions: v => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return v2._1; }
            $runtime.fail();
          }
        });
        return {
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
            Data$dList$dTypes.Nil
          )
        };
      })());
      const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Valid"})((() => {
        const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "value"})(dictEncodeWithOptions))({
          reflectSymbol: () => "editValue"
        })({
          encodeWithOptions: v => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return v2._1; }
            $runtime.fail();
          }
        });
        return {
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
            Data$dList$dTypes.Nil
          )
        };
      })());
      return {
        encodeOpts: opts => v => {
          if (v.tag === "Inl") {
            return $0.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1);
          }
          if (v.tag === "Inr") {
            if (v._1.tag === "Inl") {
              return $1.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1);
            }
            if (v._1.tag === "Inr") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1);
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
      };
    })())
  }
);
const dynamicFromContextDef = d => key => ctxRef => Specular$dFRP$dBase.bindDynamic.bind(ctxRef._1)(context1 => {
  const $0 = (() => {
    const n = Specular$dInternal$dIncremental.constant(d);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })();
  const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(key)(context1);
  if ($1.tag === "Just") { return $1._1; }
  return $0;
});
const dynamicFromContext = dictHasContext => key => field => Specular$dFRP$dBase.bindDynamic.bind(dictHasContext.getContext(field))(context1 => Data$dTraversable.traversableMaybe.sequence(Specular$dFRP$dBase.applicativeDynamic)((() => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(key)(context1);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0._1); }
  return Data$dMaybe.Nothing;
})()));
const dumpStateRecordNil = {
  dumpStateRecord: v => v1 => {
    const n = Specular$dInternal$dIncremental.constant(Foreign$dObject.empty);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const dumpStateRecord = dict => dict.dumpStateRecord;
const dumpState_Record = () => dictDumpStateRecord => (
  {
    dumpState: (() => {
      const $0 = Specular$dFRP$dBase.functorDynamic.map(x => Foreign$dObject._mapWithKey(x, v => Foreign$dGeneric$dClass.foreignEncode.encode));
      const $1 = dictDumpStateRecord.dumpStateRecord(Type$dProxy.Proxy);
      return x => $0($1(x));
    })()
  }
);
const dumpState = dict => dict.dumpState;
const dumpStateRecordCons = dictIsSymbol => dictDumpStateRecord => dictDumpState => () => () => (
  {
    dumpStateRecord: v => f => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v1 => v2 => {
      const $0 = dictIsSymbol.reflectSymbol(Type$dProxy.Proxy);
      return Foreign$dObject.mutate($1 => () => {
        $1[$0] = v1;
        return $1;
      })(v2);
    })(dictDumpState.dumpState(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f))))(dictDumpStateRecord.dumpStateRecord(Type$dProxy.Proxy)(f))
  }
);
const displayedErrors = dict => dict.displayedErrors;
const hasDisplayedErrors = dictHasErrors => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(x => x.length !== 0);
  return x => $0(dictHasErrors.displayedErrors(x));
};
const hasErrorsMappedField = dictHasErrors => ({displayedErrors: v => dictHasErrors.displayedErrors(v.field)});
const hasErrorsRefWithOptions = dictHasErrors => ({displayedErrors: v => dictHasErrors.displayedErrors(v.field)});
const hasErrorsWithId = dictHasErrors => ({displayedErrors: v => dictHasErrors.displayedErrors(v._1.field)});
const hasErrorsWithOptions = dictHasErrors => ({displayedErrors: v => dictHasErrors.displayedErrors(v.field)});
const displayLocaleKey = /* #__PURE__ */ Data$dVault.newKey();
const displayLocale = /* #__PURE__ */ Data$dVault.singleton(displayLocaleKey);
const defineForm = dictMonadFRP => v => Specular$dFRP$dHost.liftHost(dictMonadFRP.MonadCleanup1())(dictMonadFRP.MonadEffect0())(v);
const make = dictMonadFRP => dictInitialize => f => Specular$dFRP$dHost.liftHost(dictMonadFRP.MonadCleanup1())(dictMonadFRP.MonadEffect0())(Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(Type$dProxy.Proxy)({
  name: []
}))(v => {
  const $0 = v.field;
  return Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dHost.liftHost(Specular$dFRP$dHost.monadCleanupHost)(Specular$dInternal$dRIO.monadEffectRIO)(v.init(NoInitialValue)(f($0))))(() => Specular$dInternal$dRIO.pureImpl($0));
}));
const define1 = f => v => v(f);
const copyState = dict => dict.copyState;
const checkboxInput = dict => dict.checkboxInput;
const isCheckboxFieldMappedFiel = dictTypeEquals => dictIsCheckboxField => (
  {
    checkboxInput: field$p => {
      const $0 = field$p.mapping;
      return Specular$dInternal$dRIO.bindImpl(dictIsCheckboxField.checkboxInput(field$p.field))(v1 => Specular$dInternal$dRIO.pureImpl({
        displayedValue: Specular$dFRP$dBase.functorDynamic.map($0)(v1.displayedValue),
        onChange: x => v1.onChange($0(x))
      }));
    }
  }
);
const isCheckboxFieldWithId = dictIsCheckboxField => ({checkboxInput: v => dictIsCheckboxField.checkboxInput(v._1.field)});
const bindFormDefM = Specular$dInternal$dRIO.bindRIO;
const makeWithEffectInitializer = dictInitialize => p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
  field: v.field,
  init: iv => v1 => Specular$dInternal$dRIO.bindImpl(v1)(initializer$p => v.init(iv)(initializer$p))
}));
const initializeEffectInitializ = dictInitialize => ({makeImpl: makeWithEffectInitializer(dictInitialize)});
const initializeRecordCons = dictIsSymbol => dictInitializeRecord => dictMaybeGetInitialValue => dictMaybeGetInitializer => dictInitialize => () => () => (
  {
    makeRecordImpl: p => v => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(Type$dProxy.Proxy)({
      name: Data$dSemigroup.concatArray(opts.name)([dictIsSymbol.reflectSymbol(Type$dProxy.Proxy)])
    }))(x => Specular$dInternal$dRIO.bindImpl(dictInitializeRecord.makeRecordImpl(p)(Type$dProxy.Proxy)(opts))(xs => Specular$dInternal$dRIO.pureImpl({
      field: x$1 => Record$dBuilder.unsafeInsert(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(x.field)(xs.field(x$1)),
      init: ivs => is => Specular$dInternal$dRIO.bindImpl(x.init(dictMaybeGetInitialValue.maybeGetInitialValue(Type$dProxy.Proxy)(ivs))(dictMaybeGetInitializer.maybeGetInitializer(Type$dProxy.Proxy)(is)))(() => xs.init(ivs)(is))
    })))
  }
);
const asRecordRecord = {fromRecord: x => x, toRecord: x => x};
const asRecordNewtype = () => ({fromRecord: Unsafe$dCoerce.unsafeCoerce, toRecord: Unsafe$dCoerce.unsafeCoerce});
const applyFormDefM = Specular$dInternal$dRIO.applyRIO;
const semigroupFormDefM = dictSemigroup => (
  {
    append: (() => {
      const $0 = dictSemigroup.append;
      return a => b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl($0)(a))(b);
    })()
  }
);
const applicativeFormDefM = Specular$dInternal$dRIO.applicativeRIO;
const define = f => Data$dFoldable.foldrArray(x => {
  const $0 = x(f);
  return b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$1 => x$1)($0))(b);
})(Specular$dInternal$dRIO.pureImpl());
const monoidFormDefM = dictMonoid => (
  {
    mempty: Specular$dInternal$dRIO.pureImpl(dictMonoid.mempty),
    Semigroup0: () => (
      {
        append: (() => {
          const $0 = dictMonoid.Semigroup0().append;
          return a => b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl($0)(a))(b);
        })()
      }
    )
  }
);
const initializeRecordNil = {makeRecordImpl: v => v1 => v2 => Specular$dInternal$dRIO.pureImpl({field: x => x, init: v3 => v4 => Specular$dInternal$dRIO.pureImpl()})};
const annotatedFinal = name => x => {
  Specular$dInternal$dIncremental$dNode.annotate(x, name);
  return x;
};
const annotateFinal = dictMonadEffect => x => Specular$dFRP$dBase.annotate(dictMonadEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(x));
const addContextRecordNil = {addContextRecord: v => v1 => v2 => () => {}};
const addContextRecord = dict => dict.addContextRecord;
const addContext_Record = () => dictAddContextRecord => ({addContext: dictAddContextRecord.addContextRecord(Type$dProxy.Proxy)});
const addContextMaybe = {addContext: v => v1 => () => {}};
const addContext = dict => dict.addContext;
const addContextRecordCons = dictIsSymbol => dictAddContextRecord => dictAddContext => () => () => (
  {
    addContextRecord: v => ctx => f => {
      const $0 = dictAddContext.addContext(ctx)(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f));
      return () => {
        $0();
        return dictAddContextRecord.addContextRecord(Type$dProxy.Proxy)(ctx)(f)();
      };
    }
  }
);
const context = dictAddContext => ctx => f => dictAddContext.addContext(ctx)(f);
const makeWithContextInitializer = dictInitialize => dictAddContext => p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => {
  const $0 = v.field;
  return Specular$dInternal$dRIO.pureImpl({
    field: $0,
    init: iv => v1 => {
      const $1 = v1._2;
      return Specular$dInternal$dRIO.bindImpl(dictAddContext.addContext(v1._1)($0))(() => v.init(iv)($1));
    }
  });
});
const initializeContextInitiali = dictAddContext => dictInitialize => ({makeImpl: makeWithContextInitializer(dictInitialize)(dictAddContext)});
const addContextT2 = dictAddContext => dictAddContext1 => (
  {
    addContext: ctx => v => {
      const $0 = v._2;
      const $1 = dictAddContext.addContext(ctx)(v._1);
      return () => {
        $1();
        return dictAddContext1.addContext(ctx)($0)();
      };
    }
  }
);
export {
  $ContextInitializer,
  $InitialValueInitializer,
  $NoInitialValue,
  $NoInitializer,
  $SomeInitialValue,
  $Strictness,
  $TypedValue,
  $WithId,
  Attribute,
  ContextInitializer,
  EffectInitializer,
  FormDefM,
  InitialValueInitializer,
  Invalid,
  Lax,
  MappedField,
  NoInitialValue,
  NoInitializer,
  RefWithOptions,
  SomeInitialValue,
  Strict,
  Undefined,
  Valid,
  WithId,
  WithOptions,
  addContext,
  addContextDynamic,
  addContextEffect,
  addContextFormField,
  addContextMaybe,
  addContextRecord,
  addContextRecordCons,
  addContextRecordNil,
  addContextRef,
  addContextT2,
  addContext_Record,
  annotateFinal,
  annotatedFinal,
  applicativeFormDefM,
  applyFormDefM,
  asRecordNewtype,
  asRecordRecord,
  bindFormDefM,
  checkboxInput,
  context,
  copyState,
  define,
  define1,
  defineForm,
  displayLocale,
  displayLocaleKey,
  displayedErrors,
  dumpState,
  dumpStateRecord,
  dumpStateRecordCons,
  dumpStateRecordNil,
  dumpState_Record,
  dynamicFromContext,
  dynamicFromContextDef,
  encodeTypedValue,
  eqStrictness,
  failFirst,
  fieldPathToString,
  forceDisplayErrors,
  forceDisplayErrorsKey,
  fromChoices,
  fromRecord,
  functorFormDefM,
  genericTypedValue,
  getContext,
  getFieldId,
  greaterThan,
  greaterThanOrEqual,
  hasContextContext,
  hasContextRefContext,
  hasDisplayedErrors,
  hasErrorsChoiceRef,
  hasErrorsErrorArray,
  hasErrorsMappedField,
  hasErrorsOldFormField,
  hasErrorsRef,
  hasErrorsRefWithOptions,
  hasErrorsWithId,
  hasErrorsWithOptions,
  hasFieldIdChoiceRef,
  hasFieldIdFormField,
  hasFieldIdRef,
  hasFieldIdRefWithOptions,
  hasFieldIdString,
  hasFieldIdWithId,
  hasFieldIdWithOptions,
  hasOptionsArray,
  hasOptionsSMultiSet,
  hasOptionsSet,
  hasOptionsSingle,
  initializeContextInitiali,
  initializeEffectInitializ,
  initializeInitialValueIni,
  initializeNoInitialValueR,
  initializeNoInitializerRe,
  initializeRecordCons,
  initializeRecordNil,
  initializeSomeInitialValu,
  isCheckboxFieldFormFieldB,
  isCheckboxFieldMappedFiel,
  isCheckboxFieldRefBoolean,
  isCheckboxFieldWithId,
  isMultiSelectFieldMultiChoiceRef,
  isRefLikeFormField,
  isRefLikeRef,
  isRefLikeWithId,
  isSelectFieldChoiceRef,
  isSelectFieldRefWithOptions,
  isSelectFieldWithId,
  isTextFieldFormFieldStrin,
  isTextFieldRefString,
  isTextFieldWithId,
  lessThan,
  lessThanOrEqual,
  liftMaybe,
  mSelectGetOptions,
  mSelectReadValue,
  mSelectTouch,
  mSelectWriteValue,
  make,
  makeEmpty,
  makeEmptyImpl,
  makeEmptyMaybe,
  makeEmptyRecord,
  makeEmptyRecordCons,
  makeEmptyRecordNil,
  makeEmptyT2,
  makeEmpty_Record,
  makeImpl,
  makeRecordImpl,
  makeWithContextInitializer,
  makeWithDefaultInitializer,
  makeWithEffectInitializer,
  makeWithInitialValueIniti,
  makeWithInitialValueIniti1,
  makeWithInitialValueInitializer,
  mapDynamicFinal,
  mapMaybeFinal,
  mapMaybeFinalInternal,
  mapMaybeFinalUserVisible,
  mapVFinal,
  maybeGetInitialValue,
  maybeGetInitialValue$p,
  maybeGetInitialValue$pFals,
  maybeGetInitialValue$pTrue,
  maybeGetInitialValue1,
  maybeGetInitializer,
  maybeGetInitializer$p,
  maybeGetInitializer$pFalse,
  maybeGetInitializer$pTrue,
  maybeGetInitializer1,
  merge,
  mergeInputRequired,
  mergeRecord,
  mergeRecordCons,
  mergeRecordNil,
  mergeRef,
  mergeT2T2,
  mergeUnit,
  merge_Record,
  monadCleanupFormDefM,
  monadEffectFormDefM,
  monadFormDefM,
  monoidFormDefM,
  nonEmpty,
  optionForEq,
  query,
  queryDynamic,
  queryFinal,
  queryFormField,
  queryLax,
  queryLaxWithDefault,
  queryRecord,
  queryRecordCons,
  queryRecordNil,
  queryRef,
  queryT2T2,
  queryUnit,
  queryWith,
  query_Record,
  readRefLike,
  requiredError,
  selectGetOptions,
  selectInput,
  selectReadValue,
  selectTouch,
  selectWriteValue,
  semigroupFormDefM,
  showTypedValue,
  singleOption,
  tagErrors,
  textInput,
  toRecord,
  touchRefLike,
  unFinalFromContext,
  unFinalFromContextDef,
  unFinalWithDefault,
  validateJust,
  validateTrue,
  validateWhenJust,
  withContext,
  withEffect,
  withFinal_,
  withId,
  withInitialValue,
  withOptions,
  writeRef,
  writeRefLike
};
